import * as React from "react";

function aboutIllustration(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 555 469" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#prefix__filter0_d_29:34)">
        <path
          d="M141.268 202.985a3.924 3.924 0 013.924-3.925h306.114a3.924 3.924 0 013.924 3.925v183.668a3.924 3.924 0 01-3.924 3.924H145.192a3.924 3.924 0 01-3.924-3.924V202.985z"
          fill="#F0F0F0"
        />
        <path d="M141.268 199.06H455.23v13.736H141.268V199.06z" fill="#fff" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M146.762 194.351c-5.418 0-9.811 4.393-9.811 9.811v181.706c0 5.418 4.393 9.811 9.811 9.811h302.974c5.418 0 9.811-4.393 9.811-9.811V204.162c0-5.418-4.393-9.811-9.811-9.811H146.762zm-1.57 4.709a3.924 3.924 0 00-3.924 3.925v183.668a3.924 3.924 0 003.924 3.924h306.114a3.924 3.924 0 003.924-3.924V202.985a3.924 3.924 0 00-3.924-3.925H145.192z"
          fill="url(#prefix__paint0_linear_29:34)"
        />
        <path
          d="M222.898 268.917c0-.867.703-1.57 1.57-1.57h220.558c.867 0 1.57.703 1.57 1.57v112.241a1.57 1.57 0 01-1.57 1.57H224.468a1.57 1.57 0 01-1.57-1.57V268.917z"
          fill="#fff"
        />
        <path
          d="M123.215 398.819a3.14 3.14 0 013.14-3.14h343.788a3.14 3.14 0 013.14 3.14v5.102a3.14 3.14 0 01-3.14 3.139H126.355a3.14 3.14 0 01-3.14-3.139v-5.102z"
          fill="#838383"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M240.166 288.736a2.944 2.944 0 012.943-2.944h128.725a2.943 2.943 0 010 5.887H243.109a2.943 2.943 0 01-2.943-2.943zM380.272 288.736a2.943 2.943 0 012.943-2.944H425.6a2.943 2.943 0 010 5.887h-42.385a2.943 2.943 0 01-2.943-2.943zM240.166 298.94a2.944 2.944 0 012.943-2.944h128.725a2.943 2.943 0 010 5.887H243.109a2.943 2.943 0 01-2.943-2.943zM380.272 298.94a2.943 2.943 0 012.943-2.944H425.6a2.943 2.943 0 010 5.887h-42.385a2.943 2.943 0 01-2.943-2.943zM240.166 309.536a2.944 2.944 0 012.943-2.944h128.725a2.943 2.943 0 010 5.887H243.109a2.943 2.943 0 01-2.943-2.943zM380.272 309.536a2.943 2.943 0 012.943-2.944H425.6a2.943 2.943 0 010 5.887h-42.385a2.943 2.943 0 01-2.943-2.943zM240.166 320.132a2.943 2.943 0 012.943-2.943h128.725a2.942 2.942 0 110 5.886H243.109a2.943 2.943 0 01-2.943-2.943zM380.272 320.132a2.942 2.942 0 012.943-2.943H425.6a2.942 2.942 0 110 5.886h-42.385a2.942 2.942 0 01-2.943-2.943zM240.166 330.728a2.943 2.943 0 012.943-2.943h128.725a2.943 2.943 0 110 5.887H243.109a2.944 2.944 0 01-2.943-2.944zM380.272 330.728a2.943 2.943 0 012.943-2.943H425.6a2.943 2.943 0 110 5.887h-42.385a2.943 2.943 0 01-2.943-2.944zM240.166 341.324a2.943 2.943 0 012.943-2.943h128.725a2.943 2.943 0 110 5.887H243.109a2.944 2.944 0 01-2.943-2.944zM380.272 341.324a2.943 2.943 0 012.943-2.943H425.6a2.943 2.943 0 110 5.887h-42.385a2.943 2.943 0 01-2.943-2.944zM240.166 351.921a2.944 2.944 0 012.943-2.944h128.725a2.943 2.943 0 010 5.887H243.109a2.943 2.943 0 01-2.943-2.943zM380.272 351.921a2.943 2.943 0 012.943-2.944H425.6a2.943 2.943 0 010 5.887h-42.385a2.943 2.943 0 01-2.943-2.943zM240.166 362.517a2.943 2.943 0 012.943-2.943h128.725a2.942 2.942 0 110 5.886H243.109a2.943 2.943 0 01-2.943-2.943zM380.272 362.517a2.942 2.942 0 012.943-2.943H425.6a2.942 2.942 0 110 5.886h-42.385a2.942 2.942 0 01-2.943-2.943z"
          fill="#EFEFEF"
        />
        <path d="M424.619 205.732a2.747 2.747 0 11-5.494 0 2.747 2.747 0 015.494 0z" fill="#DB5F78" />
        <path d="M434.038 205.732a2.747 2.747 0 11-5.494 0 2.747 2.747 0 015.494 0z" fill="#FABF05" />
        <path d="M443.457 205.732a2.747 2.747 0 11-5.495 0 2.747 2.747 0 015.495 0z" fill="#17CC38" />
        <path d="M299.426 196.706a1.177 1.177 0 11-2.354 0 1.177 1.177 0 012.354 0z" fill="#646464" />
        <path d="M443.849 401.37a.98.98 0 11-1.961 0 .98.98 0 011.961 0z" fill="#17CC38" />
        <path
          d="M212.498 329.551c-1.413-2.983-6.737-3.598-9.223-3.532h-3.139l-12.166 15.109c-1.439 1.243-3.454 4.435 0 7.261 3.453 2.825 8.11 3.401 10.007 3.336l-.785.981 4.317-2.355 8.831-3.925 3.532-13.932c.13.262.039.04-1.374-2.943z"
          fill="#C7873D"
        />
        <path
          d="M208.966 343.679c-11.931 1.884-13.867 8.242-13.343 11.185l3.728-1.373c5.808-2.355 7.391-.066 7.457 1.373 1.412-1.256 4.513-2.355 5.886-2.747l2.159-6.279 3.139-4.121 1.374-4.709 9.419-7.457h-16.091c-4.866 4.395-4.513 11.25-3.728 14.128z"
          fill="url(#prefix__paint1_linear_29:34)"
        />
        <path
          d="M214.264 336.223c-3.296 4.866-2.158 9.222-1.177 10.792l5.69-4.906c2.983-1.883 4.644-.392 5.102.589 4.71-4.081 5.495-10.465 5.298-13.147h-7.456c-1.112.196-4.16 1.805-7.457 6.672z"
          fill="url(#prefix__paint2_linear_29:34)"
        />
        <path
          d="M194.445 360.359c.72-.131 2.944-.707 6.083-1.963 3.14-1.256 5.233-2.224 5.887-2.551l.589-1.373c-.393-1.505-2.865-3.729-9.615-.589l-3.925 1.374c-.392.785-1.059 2.629-.589 3.728.471 1.099 1.243 1.374 1.57 1.374z"
          fill="url(#prefix__paint3_linear_29:34)"
        />
        <path
          d="M214.952 352.208c.595-.425 2.361-1.894 4.666-4.368s3.786-4.242 4.238-4.817l-.053-1.493c-.996-1.194-4.181-2.152-8.949 3.565l-2.964 2.916c-.021.877.162 2.83 1.056 3.623.894.794 1.71.713 2.006.574z"
          fill="url(#prefix__paint4_linear_29:34)"
        />
        <g filter="url(#prefix__filter1_d_29:34)">
          <path
            d="M201.313 250.864c0-.867.703-1.57 1.57-1.57h160.906a1.57 1.57 0 011.569 1.57v78.098a1.57 1.57 0 01-1.569 1.57H202.883a1.57 1.57 0 01-1.57-1.57v-78.098z"
            fill="#fff"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M205.63 253.611v72.604h155.412v-72.604H205.63zm-2.747-4.317a1.57 1.57 0 00-1.57 1.57v78.098c0 .867.703 1.57 1.57 1.57h160.906a1.57 1.57 0 001.569-1.57v-78.098a1.57 1.57 0 00-1.569-1.57H202.883z"
            fill="#D26379"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M220.543 278.14a3.336 3.336 0 013.336-3.336h118.913a3.335 3.335 0 110 6.671H223.879a3.336 3.336 0 01-3.336-3.335zM220.543 290.306a3.336 3.336 0 013.336-3.336h118.913a3.335 3.335 0 110 6.671H223.879a3.336 3.336 0 01-3.336-3.335zM220.543 302.472a3.336 3.336 0 013.336-3.336h118.913a3.335 3.335 0 110 6.672H223.879a3.337 3.337 0 01-3.336-3.336zM220.543 314.638a3.336 3.336 0 013.336-3.336h118.913a3.335 3.335 0 110 6.671H223.879a3.336 3.336 0 01-3.336-3.335z"
            fill="#B7B7B7"
          />
        </g>
        <path
          d="M220.347 322.094l-19.426 6.476-1.766-8.83 29.041-14.129c2.551-.654 7.849-.863 8.634 3.532.785 4.396-2.158 7.326-3.728 8.242l-12.755 4.709z"
          fill="#C4C4C4"
          fillOpacity={0.23}
        />
        <path
          d="M172.86 309.928c-11.773 23.391-29.63 36.564-37.086 40.227l20.996 20.8c2.551-2.159 5.298-.785 11.381-2.159 4.866-1.099 8.83-5.167 10.204-7.064l10.007-11.577c5.652-4.553 10.989-16.025 12.951-21.193l4.513-2.354 7.653-3.14s9.027-3.532 17.464-6.868c4.577-1.809 5.495-7.26 2.355-11.97-3.14-4.709-17.924 1.464-23.94 4.71-6.671 3.599-7.26 5.102-8.045 3.532v-19.23h-1.373c-2.421.392-8.32 1.177-12.559 1.177-7.221.628-10.596 6.148-11.381 8.83l-3.14 6.279z"
          fill="url(#prefix__paint5_linear_29:34)"
        />
        <path
          d="M222.898 304.826c-.065 1.897.628 6.319 3.925 8.831 0 0 5.102-1.178 9.419-4.121 4.316-2.944 6.279-4.121 4.709-7.261-1.276-2.55-3.336-1.766-8.045-.784l-10.008 3.335z"
          fill="url(#prefix__paint6_linear_29:34)"
        />
        <path
          d="M82.989 390.381c-10.06 9.916-33.11 23.547-56.505 46.555-2.5 2.459-.727 6.623 2.78 6.623h59.138a11 11 0 007.824-3.268l13.253-13.412c9.746-9.026 31.514-28.963 40.619-36.498 15.07-8.948 11.25-19.034 7.457-22.958-2.486-3.205-9.733-11.303-18.838-18.053s-18.445 2.812-21.977 8.438c-7.392 8.634-22.763 21.741-33.751 32.573z"
          fill="url(#prefix__paint7_linear_29:34)"
        />
        <path
          d="M120.076 356.238c1.242-3.598 5.847-10.439 14.324-9.027 8.477 1.413 17.791 10.597 23.155 18.053 6.775 9.419 4.513 17.464-4.906 21.781l2.551-3.139.981-2.551-.981-4.121-25.313-24.332-3.532-1.374h-1.963l-4.316 4.71z"
          fill="url(#prefix__paint8_linear_29:34)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M124.923 352.927c-1.414.879-2.593 2.493-3.266 3.55a1.177 1.177 0 01-1.986-1.264c.701-1.101 2.115-3.109 4.009-4.286.968-.601 2.129-1.029 3.42-.94 1.306.089 2.588.695 3.803 1.873 1.5 1.455 4.189 3.933 7.257 6.76 5.398 4.974 11.969 11.028 15.303 14.495 1.56 1.622 3.291 4.051 3.751 6.679.236 1.342.143 2.76-.502 4.126-.644 1.363-1.792 2.574-3.499 3.583a1.177 1.177 0 01-1.198-2.027c1.392-.823 2.165-1.711 2.568-2.562.401-.849.479-1.761.312-2.713-.344-1.962-1.711-3.979-3.13-5.454-3.303-3.435-9.693-9.32-15.039-14.245-3.113-2.867-5.872-5.408-7.463-6.951-.901-.874-1.682-1.171-2.324-1.215-.657-.045-1.33.164-2.016.591z"
          fill="#fff"
        />
        <path d="M151.079 379.981a2.747 2.747 0 11-5.494 0 2.747 2.747 0 015.494 0z" fill="#fff" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.638 194.351a3.925 3.925 0 100-7.85 3.925 3.925 0 000 7.85zm0 1.177a5.102 5.102 0 100-10.204 5.102 5.102 0 000 10.204z"
          fill="#D26379"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.49 346.23a5.69 5.69 0 100-11.381 5.69 5.69 0 000 11.381zm0 2.355a8.045 8.045 0 100-16.091 8.045 8.045 0 000 16.091zM133.223 79.755a5.69 5.69 0 10-.001-11.381 5.69 5.69 0 00.001 11.38zm0 2.354a8.045 8.045 0 000-16.09 8.045 8.045 0 100 16.09zM463.275 107.619a5.691 5.691 0 100-11.382 5.691 5.691 0 000 11.382zm0 2.355a8.046 8.046 0 100-16.091 8.046 8.046 0 000 16.091z"
          fill="#7053D2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M104.377 322.683a2.355 2.355 0 100-4.71 2.355 2.355 0 000 4.71zm0 1.177a3.532 3.532 0 100-7.063 3.532 3.532 0 000 7.063zM334.355 420.404a2.355 2.355 0 10-.002-4.71 2.355 2.355 0 00.002 4.71zm0 1.177a3.532 3.532 0 100-7.064 3.532 3.532 0 000 7.064z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M283.336 144.902a3.924 3.924 0 100-7.849 3.924 3.924 0 000 7.849zm0 1.177a5.102 5.102 0 100-10.203 5.102 5.102 0 000 10.203zM312.377 24.026a3.925 3.925 0 100-7.849 3.925 3.925 0 000 7.85zm0 1.178a5.102 5.102 0 100-10.204 5.102 5.102 0 000 10.204z"
          fill="#D26379"
        />
        <circle cx={473.087} cy={304.041} r={66.913} fill="#A28DE9" />
        <path d="M476.574 351.289a3.336 3.336 0 11-6.672 0 3.336 3.336 0 016.672 0z" fill="#696969" />
        <path
          d="M464.064 336.572c-.393-4.644-3.062-15.462-10.597-21.584-7.535-6.123-7.98-18.904-7.26-24.529.981-6.999 7.81-21.231 27.275-22.173 19.466.942 26.295 15.174 27.276 22.173.719 5.625.275 18.406-7.26 24.529-7.536 6.122-10.204 16.94-10.597 21.584h-18.837z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M471.249 312.286c-.339.598-.404 1.346-.348 1.852l.004.032v23.384h-1.178v-23.32c-.068-.672.01-1.67.499-2.53.523-.92 1.487-1.622 3.033-1.622 1.546 0 2.51.702 3.033 1.622.49.86.568 1.858.499 2.53v23.32h-1.177V314.17l.004-.032c.056-.506-.009-1.254-.349-1.852-.314-.552-.887-1.027-2.01-1.027-1.123 0-1.696.475-2.01 1.027z"
          fill="#D26379"
        />
        <path
          d="M461.66 339.32v10.596l2.748 2.747h17.66l2.747-2.747V339.32l-1.962-2.747h-18.838l-2.355 2.747z"
          fill="url(#prefix__paint9_linear_29:34)"
        />
        <path
          stroke="#6C6C6C"
          strokeWidth={3}
          strokeLinecap="round"
          d="M463.682 341.486l18.592-1.352M463.682 344.233l18.592-1.352M463.682 346.98l18.592-1.352"
        />
        <path
          d="M459.458 291.334c.433 0 .785.351.785.785v8.348a.786.786 0 01-.785.785h-.846a.785.785 0 01-.785-.785v-8.348c0-.434.351-.785.785-.785h.846zM465.709 291.334c1.046 0 1.96.207 2.741.621a4.39 4.39 0 011.809 1.752c.433.744.65 1.606.65 2.586 0 .97-.217 1.832-.65 2.585a4.36 4.36 0 01-1.823 1.752c-.782.415-1.69.622-2.727.622h-2.93a.785.785 0 01-.785-.785v-8.348c0-.434.351-.785.785-.785h2.93zm-.155 7.827c.914 0 1.625-.25 2.133-.749.509-.499.763-1.206.763-2.119 0-.914-.254-1.625-.763-2.134-.508-.508-1.219-.763-2.133-.763h-.359a.785.785 0 00-.785.785v4.195c0 .433.351.785.785.785h.359zM475.46 293.269a.785.785 0 00-.785.785v.437c0 .433.351.784.785.784h1.665c.434 0 .785.352.785.785v.296a.784.784 0 01-.785.784h-1.665a.785.785 0 00-.785.785v.606c0 .434.351.785.785.785h2.089c.434 0 .785.352.785.785v.366a.785.785 0 01-.785.785h-4.505a.785.785 0 01-.785-.785v-8.348c0-.434.351-.785.785-.785h4.505c.434 0 .785.351.785.785v.365a.784.784 0 01-.785.785h-2.089zM486.257 300.033a.784.784 0 00-.743-.533h-2.576a.785.785 0 00-.744.533l-.232.686a.786.786 0 01-.743.533h-.848a.785.785 0 01-.738-1.052l3.021-8.348a.784.784 0 01.738-.518h1.696c.33 0 .625.207.738.518l3.021 8.348a.785.785 0 01-.739 1.052h-.875a.786.786 0 01-.744-.533l-.232-.686zm-1.896-2.398a.785.785 0 00.743-1.037l-.131-.385c-.241-.712-1.249-.711-1.487.002l-.129.386a.785.785 0 00.744 1.034h.26z"
          fill="#D26379"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M460.515 308.998c-1.669-2.623-1.998-5.828-1.796-7.979l.781.073c-.191 2.035.128 5.051 1.677 7.484 1.529 2.402 4.286 4.286 9.099 4.057l.037.784c-5.077.242-8.109-1.766-9.798-4.419zM486.353 308.801c1.669-2.623 1.998-5.827 1.796-7.978l-.781.073c.191 2.035-.128 5.05-1.677 7.484-1.529 2.402-4.286 4.286-9.099 4.057l-.037.784c5.077.242 8.109-1.766 9.798-4.42z"
          fill="#D26379"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M448.293 319.281a.59.59 0 010-.833l2.307-2.307a.59.59 0 01.833.833l-2.307 2.307a.59.59 0 01-.833 0zM439.734 317.648a.588.588 0 01.138-.821l7.945-5.662a.59.59 0 01.683.959l-7.945 5.662a.59.59 0 01-.821-.138zM439.839 309.347a.588.588 0 01.302-.776l5.173-2.274a.59.59 0 01.474 1.078l-5.174 2.274a.588.588 0 01-.775-.302zM432.936 301.845a.589.589 0 01.508-.659l10.97-1.419a.589.589 0 11.151 1.168l-10.97 1.419a.59.59 0 01-.659-.509zM435.366 295.561a.59.59 0 01.589-.589h7.849a.59.59 0 010 1.178h-7.849a.59.59 0 01-.589-.589zM433.123 286.938a.589.589 0 01.69-.466l11.01 2.131a.588.588 0 11-.224 1.156l-11.01-2.131a.589.589 0 01-.466-.69zM442.27 281.873a.588.588 0 01.773-.309l4.412 1.891a.588.588 0 11-.464 1.082l-4.412-1.891a.588.588 0 01-.309-.773zM440.411 272.119a.588.588 0 01.819-.149l9.235 6.394a.588.588 0 11-.67.968l-9.235-6.394a.588.588 0 01-.149-.819zM448.716 270.6a.588.588 0 01.832-.033l4.237 3.911a.588.588 0 11-.799.865l-4.236-3.911a.59.59 0 01-.034-.832zM451.554 261.287a.588.588 0 01.816.164l6.411 9.616a.588.588 0 11-.979.653l-6.411-9.616a.588.588 0 01.163-.817zM460.239 261.382a.59.59 0 01.773.309l3.069 7.16a.589.589 0 11-1.083.463l-3.068-7.159a.588.588 0 01.309-.773zM466.954 253.296a.587.587 0 01.66.507l1.809 13.745a.59.59 0 01-1.168.154l-1.808-13.746a.587.587 0 01.507-.66zM498.182 319.281a.59.59 0 000-.833l-2.307-2.307a.588.588 0 10-.832.833l2.307 2.307c.23.23.602.23.832 0zM506.742 317.648a.589.589 0 00-.138-.821l-7.945-5.662a.59.59 0 00-.683.959l7.945 5.662a.59.59 0 00.821-.138zM506.637 309.347a.59.59 0 00-.302-.776l-5.173-2.274a.59.59 0 00-.474 1.078l5.173 2.274a.59.59 0 00.776-.302zM513.54 301.845a.59.59 0 00-.509-.659l-10.97-1.419a.588.588 0 10-.151 1.168l10.97 1.419a.59.59 0 00.66-.509zM511.109 295.561a.589.589 0 00-.588-.589h-7.849a.59.59 0 000 1.178h7.849a.589.589 0 00.588-.589zM513.352 286.938a.587.587 0 00-.689-.466l-11.011 2.131a.59.59 0 00.224 1.156l11.01-2.131a.589.589 0 00.466-.69zM504.206 281.873a.588.588 0 00-.773-.309l-4.412 1.891a.588.588 0 10.464 1.082l4.412-1.891a.588.588 0 00.309-.773zM506.065 272.119a.588.588 0 00-.819-.149l-9.236 6.394a.589.589 0 00.67.968l9.236-6.394a.589.589 0 00.149-.819zM497.759 270.6a.588.588 0 00-.832-.033l-4.236 3.911a.59.59 0 00.798.865l4.237-3.911a.588.588 0 00.033-.832zM494.922 261.287a.59.59 0 00-.817.164l-6.411 9.616a.59.59 0 00.98.653l6.411-9.616a.59.59 0 00-.163-.817zM486.236 261.382a.59.59 0 00-.773.309l-3.068 7.16a.588.588 0 101.082.463l3.068-7.159a.588.588 0 00-.309-.773zM474.023 258.082c.325 0 .588.263.588.589v8.241a.589.589 0 11-1.177 0v-8.241c0-.326.264-.589.589-.589zM479.522 253.296a.587.587 0 00-.66.507l-1.809 13.745a.589.589 0 101.167.154l1.809-13.746a.589.589 0 00-.507-.66z"
          fill="#fff"
        />
      </g>
      <defs>
        <linearGradient
          id="prefix__paint0_linear_29:34"
          x1={136.951}
          y1={395.679}
          x2={459.547}
          y2={194.351}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0B0B0" />
          <stop offset={1} stopColor="#D7D5D5" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear_29:34"
          x1={201.902}
          y1={345.249}
          x2={210.732}
          y2={352.509}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDA249" />
          <stop offset={1} stopColor="#FFC582" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear_29:34"
          x1={210.732}
          y1={336.419}
          x2={227.608}
          y2={340.147}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9B25F" />
          <stop offset={1} stopColor="#FDE7CE" />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear_29:34"
          x1={198.762}
          y1={353.491}
          x2={200.332}
          y2={358.004}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.487} stopColor="#C4C4C4" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="prefix__paint4_linear_29:34"
          x1={215.93}
          y1={344.155}
          x2={219.273}
          y2={347.568}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.487} stopColor="#C4C4C4" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="prefix__paint5_linear_29:34"
          x1={140.483}
          y1={347.015}
          x2={218.777}
          y2={329.355}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9B25F" />
          <stop offset={1} stopColor="#FFDEB7" />
        </linearGradient>
        <linearGradient
          id="prefix__paint6_linear_29:34"
          x1={231.14}
          y1={302.275}
          x2={233.887}
          y2={310.713}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={0.42} stopColor="#DDD" />
        </linearGradient>
        <linearGradient
          id="prefix__paint7_linear_29:34"
          x1={81.223}
          y1={392.54}
          x2={112.815}
          y2={422.562}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6040CA" />
          <stop offset={1} stopColor="#AC98EE" />
        </linearGradient>
        <linearGradient
          id="prefix__paint8_linear_29:34"
          x1={127.728}
          y1={347.8}
          x2={161.283}
          y2={379.981}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B23850" />
          <stop offset={1} stopColor="#DB8495" />
        </linearGradient>
        <linearGradient
          id="prefix__paint9_linear_29:34"
          x1={461.66}
          y1={344.422}
          x2={484.815}
          y2={344.422}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#535353" />
          <stop offset={1} stopColor="#A8A8A8" />
        </linearGradient>
        <filter
          id="prefix__filter0_d_29:34"
          x={0.313}
          y={0}
          width={554.687}
          height={468.559}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx={-5} dy={5} />
          <feGaussianBlur stdDeviation={10} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_29:34" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_29:34" result="shape" />
        </filter>
        <filter
          id="prefix__filter1_d_29:34"
          x={201.313}
          y={249.294}
          width={189.045}
          height={102.238}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx={21} dy={17} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_29:34" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_29:34" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default aboutIllustration;
